/**
 * דיבוג זרימת reply (שליחה / סוקט / חילוץ).
 *
 * הפעלה בקונסול הדפדפן:
 *   localStorage.setItem('debugChatReply', '1')
 *   location.reload()
 *
 * כיבוי:
 *   localStorage.removeItem('debugChatReply')
 *   location.reload()
 */
const STORAGE_KEY = 'debugChatReply';

export function isChatReplyDebugEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function logChatReply(phase: string, data: unknown): void {
  if (!isChatReplyDebugEnabled()) return;
  console.log(`[chat-reply] ${phase}`, data);
}

/** מפתחות שמצביעים על תגובה / quote ב-payload (לא לוג על כל הודעה). */
export function payloadLooksLikeReplyMetadata(m: Record<string, unknown>): boolean {
  return Object.keys(m).some((k) => /reply|quoted|parent|context|reference/i.test(k));
}
